import { render } from "./CategorySelectFacet.vue?vue&type=template&id=3f74daca"
import script from "./CategorySelectFacet.vue?vue&type=script&lang=js"
export * from "./CategorySelectFacet.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__